import WorkdayModel from "../models/workday";
import EntryModel from "../models/entry";
import WeekModel from "../models/week";

export default [
    new WeekModel(1,
        [
            new WorkdayModel(
                [
                    new EntryModel(1, 'Testeintrag 1', new Date(2018, 0, 1, 1, 0), new Date(2018, 0, 1, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(2, 'Testeintrag 2', new Date(2018, 0, 1, 3, 0), new Date(2018, 0, 1, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(3, 'Testeintrag 3', new Date(2018, 0, 1, 5, 0), new Date(2018, 0, 1, 6, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(4, 'Testeintrag 4', new Date(2018, 0, 1, 19, 30), new Date(2018, 0, 1, 20, 0), 'RWAB3.27', 'IMP'),
                ]
            ),
            new WorkdayModel(
                [
                    new EntryModel(5, 'Aasdf 1', new Date(2018, 0, 2, 1, 0), new Date(2018, 0, 2, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(6, 'Testeintrag 2', new Date(2018, 0, 2, 3, 0), new Date(2018, 0, 2, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(7, 'Testei2ffwentrag 3', new Date(2018, 0, 2, 5, 0), new Date(2018, 0, 2, 6, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(8, 'Testeintrag 4', new Date(2018, 0, 2, 5, 30), new Date(2018, 0, 2, 7, 0), 'RWAB3.27', 'IMP'),
                ]
            ),
            new WorkdayModel(
                [
                    new EntryModel(9, 'Aasdf 1', new Date(2018, 0, 3, 1, 0), new Date(2018, 0, 3, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(10, 'Testeintrag 2', new Date(2018, 0, 3, 3, 0), new Date(2018, 0, 3, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(11, 'Testei2ffwentrag 3', new Date(2018, 0, 3, 5, 0), new Date(2018, 0, 3, 6, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(12, 'Testeintrag 4', new Date(2018, 0, 3, 5, 30), new Date(2018, 0, 3, 7, 0), 'RWAB3.27', 'IMP'),
                ]
            ),
            new WorkdayModel(
                [
                    new EntryModel(13, 'Aasdf 1', new Date(2018, 0, 4, 1, 0), new Date(2018, 0, 4, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(14, 'Testeintrag 2', new Date(2018, 0, 4, 3, 0), new Date(2018, 0, 4, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(16, 'Testeintrag 4', new Date(2018, 0, 4, 5, 30), new Date(2018, 0, 4, 7, 0), 'RWAB3.27', 'IMP'),
                ]
            ),
            new WorkdayModel(
                [
                    new EntryModel(18, 'Aasdf 1', new Date(2018, 0, 5, 1, 0), new Date(2018, 0, 5, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(19, 'Testeintrag 2', new Date(2018, 0, 5, 3, 0), new Date(2018, 0, 5, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(20, 'Testei2ffwentrag 3', new Date(2018, 0, 5, 5, 0), new Date(2018, 0, 5, 6, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(21, 'Testeintrag 4', new Date(2018, 0, 5, 5, 30), new Date(2018, 0, 5, 7, 0), 'RWAB3.27', 'IMP'),
                ]
            )
        ]
    ),
    new WeekModel(2,
        [
            new WorkdayModel(
                [
                    new EntryModel(22, 'Testeintrag 1', new Date(2018, 0, 1, 1, 0), new Date(2018, 0, 1, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(23, 'Testeintrag 2', new Date(2018, 0, 1, 3, 0), new Date(2018, 0, 1, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(24, 'Testeintrag 3', new Date(2018, 0, 1, 5, 0), new Date(2018, 0, 1, 6, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(25, 'Testeintrag 4', new Date(2018, 0, 1, 5, 30), new Date(2018, 0, 1, 7, 0), 'RWAB3.27', 'IMP'),
                ]
            ),
            new WorkdayModel(
                [
                    new EntryModel(27, 'Aasdf 1', new Date(2018, 0, 2, 1, 0), new Date(2018, 0, 2, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(28, 'Testeintrag 2', new Date(2018, 0, 2, 3, 0), new Date(2018, 0, 2, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(29, 'Testei2ffwentrag 3', new Date(2018, 0, 2, 5, 0), new Date(2018, 0, 2, 6, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(43, 'Testei2ffwentrag 8', new Date(2018, 0, 2, 15, 0), new Date(2018, 0, 2, 18, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(44, 'Testei2ffwentrag 9', new Date(2018, 0, 2, 22, 0), new Date(2018, 0, 2, 22, 15), 'RWAB3.27', 'IMP'),
                    new EntryModel(30, 'Testeintrag 4', new Date(2018, 0, 2, 23, 30), new Date(2018, 0, 2, 23, 45), 'RWAB3.27', 'IMP'),
                ]
            ),
            new WorkdayModel(
                [
                    new EntryModel(31, 'Aasdf 1', new Date(2018, 0, 2, 1, 0), new Date(2018, 0, 2, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(32, 'Testeintrag 2', new Date(2018, 0, 2, 3, 0), new Date(2018, 0, 2, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(33, 'Testei2ffwentrag 3', new Date(2018, 0, 2, 5, 0), new Date(2018, 0, 2, 6, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(34, 'Testeintrag 4', new Date(2018, 0, 2, 5, 30), new Date(2018, 0, 2, 7, 0), 'RWAB3.27', 'IMP'),
                ]
            ),
            new WorkdayModel(
                [
                    new EntryModel(35, 'Aasdf 1', new Date(2018, 0, 2, 1, 0), new Date(2018, 0, 2, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(36, 'Testeintrag 2', new Date(2018, 0, 2, 3, 0), new Date(2018, 0, 2, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(37, 'Testei2ffwentrag 3', new Date(2018, 0, 2, 5, 0), new Date(2018, 0, 2, 6, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(38, 'Testeintrag 4', new Date(2018, 0, 2, 6, 30), new Date(2018, 0, 2, 7, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(50, 'Testeintrag 4', new Date(2018, 0, 2, 23, 45), new Date(2018, 0, 3, 0, 0), 'RWAB3.27', 'IMP'),
                ]
            ),
            new WorkdayModel(
                [
                    new EntryModel(39, 'Aasdf 1', new Date(2018, 0, 2, 1, 0), new Date(2018, 0, 2, 2, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(40, 'Testeintrag 2', new Date(2018, 0, 2, 3, 0), new Date(2018, 0, 2, 5, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(41, 'Testei2ffwentrag 3', new Date(2018, 0, 2, 5, 0), new Date(2018, 0, 2, 6, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(42, 'Testeintrag 4', new Date(2018, 0, 2, 7, 0), new Date(2018, 0, 2, 8, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(45, 'Testeintrag 4', new Date(2018, 0, 2, 9, 30), new Date(2018, 0, 2, 10, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(46, 'Testeintrag 4', new Date(2018, 0, 2, 12, 30), new Date(2018, 0, 2, 14, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(47, 'Testeintrag 4', new Date(2018, 0, 2, 15, 30), new Date(2018, 0, 2, 17, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(48, 'Testeintrag 4', new Date(2018, 0, 2, 22, 45), new Date(2018, 0, 2, 23, 0), 'RWAB3.27', 'IMP'),
                    new EntryModel(49, 'Testeintrag 4', new Date(2018, 0, 2, 23, 45), new Date(2018, 0, 3, 0, 0), 'RWAB3.27', 'IMP'),
                ]
            )
        ]
    ),
    new WeekModel(4,
        [
            new WorkdayModel(
                [
                    new EntryModel(51, 'Testeintrag 4', new Date(2018, 0, 2, 23, 45), new Date(2018, 0, 3, 0, 0), 'RWAB3.27', 'IMP'),
                ]
            )
        ]
    )
];



// WEBPACK FOOTER //
// ./src/data/testdata.js